<cac-dialog-layout (onSubmit)="onSubmit()" [showCloseBtn]="false">
    <feature-editor [control]="control"></feature-editor>
</cac-dialog-layout>
